<form [formGroup]="formRecipe">
  <app-recipes-form-edit
    [formRecipe]="formRecipe"
    [recipeOriginal]="recipeOriginal"
    [yieldUnits]="yieldUnits$ | async"
    *ngIf="isEdit"
    (updateRecipe)="updateRecipe($event)"
  ></app-recipes-form-edit>
  <app-recipes-form-new
    [formRecipe]="formRecipe"
    [yieldUnits]="(yieldUnits$ | async) || {}"
    (save)="save()"
    *ngIf="!isEdit"
  ></app-recipes-form-new>
</form>
